import { render, staticRenderFns } from "./operatorRemindList.vue?vue&type=template&id=7b087f40&scoped=true"
import script from "./operatorRemindList.vue?vue&type=script&lang=js"
export * from "./operatorRemindList.vue?vue&type=script&lang=js"
import style0 from "./operatorRemindList.vue?vue&type=style&index=0&id=7b087f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b087f40",
  null
  
)

export default component.exports